import React from "react";
import Input from "./Input";

interface LabeledInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  onValueChange?: (value: string) => void;
  mediaUri?: string;
}

export default function LabeledInput({
  label,
  mediaUri,
  value,
  ...rest
}: LabeledInputProps) {
  return (
    <div className="flex w-full flex-col gap-1">
      {!!label && <p className="text-lg font-bold">{label}</p>}
      <Input value={value?.toString()} {...rest} />
      {!!mediaUri && (
        <img
          className="aspect-square h-[300px] object-contain"
          alt="Uploaded media"
          src={mediaUri}
        />
      )}
    </div>
  );
}
